export default async function requestRequisicaoSegura(dataEncriptada: string) {
  return await fetch(
    `${process.env.NEXT_PUBLIC_API_URL!}/api/requisicao-segura`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        dataEncriptada,
      }),
    },
  );
}
